import { useQuery } from "@tanstack/react-query";
import { apiRequest, type Capabilities } from "@kkp/api-client";

export const CAPABILITIES_KEY = ["capabilities"] as const;

export function useCapabilities() {
  return useQuery({
    queryKey: CAPABILITIES_KEY,
    queryFn: () => apiRequest<Capabilities>({ path: "/capabilities" }),
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: true,
  });
}

export function FdsInactiveBanner({ fds }: { fds: boolean | undefined }) {
  if (fds !== false) return null;
  return (
    <div
      role="status"
      className="rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm font-semibold text-amber-100"
    >
      FDS is not active in the sandbox environment
    </div>
  );
}
